<template>
  <AuthCard>
    <div class="text-center"><h4>Reset password</h4></div>
    <form @submit.prevent="resetPassword">
      <Input v-model="email" label="E-mail" name="email" :disabled="loading" />
      <div class="flex wrap align-center mt-4">
        <div class="xs12">
          <Button
            type="submit"
            variant="smooth primary"
            :disabled="loading"
            class="mb-2 width100"
            :loading="loading"
          >
            Reset password
          </Button>
        </div>
        <div class="xs12 text-center pt-5">
          Already have an account?
          <router-link class="ml-3" to="signIn">Sign in</router-link>
        </div>
        <div class="xs12 text-center pt-5">
          Don't have an account?
          <router-link class="ml-3" to="signUp">Create an account</router-link>
        </div>
      </div>
    </form>
  </AuthCard>
</template>

<script>
  import Button from '../common/Button.vue'
  import Input from '../common/Input.vue'
  import AuthCard from '../common/AuthCard.vue'

  export default {
    name: 'ResetPassword',
    components: { Button, Input, AuthCard },
    data: () => ({ loading: false, email: '' }),
    methods: {
      async resetPassword() {
        this.loading = true
        await this.$store.dispatch('resetPassword', this.email)
        this.loading = false
      }
    }
  }
</script>
